export interface CampoJuegoTipoTribunaJSON {
  cjtt_id: string | null;
  cjtt_descripcion: string;
  cjtt_activo: boolean;
}

export class CampoJuegoTipoTribuna {
  protected constructor(private id: string | null, private descripcion: string, private activo: boolean) {}

  static createFrom(id: string | null, descripcion: string, activo: boolean) {
    return new this(id, descripcion, activo);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: CampoJuegoTipoTribuna) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: CampoJuegoTipoTribunaJSON) {
    return CampoJuegoTipoTribuna.createFrom(entity.cjtt_id, entity.cjtt_descripcion, entity.cjtt_activo);
  }

  toJSON(): CampoJuegoTipoTribunaJSON {
    return {
      cjtt_id: this.getId(),
      cjtt_descripcion: this.getDescripcion(),
      cjtt_activo: this.getActivo(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getDescripcion(): string {
    return this.descripcion;
  }

  getActivo(): any {
    return this.activo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setDescripcion(value: string): void {
    this.descripcion = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }
}
